import React, { Component } from 'react';
import TableHead from './TableHead';
import TableBody from './TableBody';

export default class Table extends Component {

    rows = {
        '/income/single': ['Count', 'Title', 'Date', 'Amount'],
        '/income/month': ['Count', 'Title', 'Day', 'Amount'],
        '/expenses/single': ['Count', 'Title', 'Date', 'Amount'],
        '/expenses/month': ['Count', 'Title', 'Day', 'Amount'],
    };

    getRows() {
        return this.rows[this.props.path];
    }

    onCellInput(value) {
        this.props.onCellInput(value);
    }

    render() {
        const style = {
            table: {
                width: '100%',
                tableLayout: 'fixed'
            }
        };
        return (
            <table style={style.table}>
                <TableHead rows={this.getRows()} />
                <TableBody rows={this.getRows()} onCellInput={this.onCellInput.bind(this)} data={this.props.data} />
            </table>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Table.js